// src/data/herbs.js
const herbs = [
  {
    name: "Chamomile",
    slug: "chamomile",
    image: "https://placehold.co/800x400?text=Chamomile",
    scientificName: "Matricaria chamomilla",
    commonUses: "Sleep aid, relaxation",
    healingBenefits: "Anti-inflammatory, calming effects",
    benefits:
      "Chamomile has been used for centuries for its soothing properties. It can help with anxiety, sleep disorders, and digestive issues.",
    culinary:
      "Chamomile is often steeped as tea and can be used to flavor desserts or syrups.",
    remedies:
      "Steep dried flowers in hot water to make a calming tea or apply cooled tea bags to puffy eyes.",
    productLinks: ["Lavender Essential Oil", "Peppermint Oil"],
  },
  {
    name: "Peppermint",
    slug: "peppermint",
    image: "https://placehold.co/800x400?text=Peppermint",
    scientificName: "Mentha × piperita",
    commonUses: "Digestion, headaches",
    healingBenefits: "Soothes stomach, clears nasal passages",
    benefits:
      "Peppermint is widely used to relieve digestive discomfort, headaches, and improve mental clarity.",
    culinary: "Used in teas, desserts, sauces, and fresh as a garnish.",
    remedies: "Infuse oil for massage or steep in tea for bloating relief.",
    productLinks: ["Peppermint Oil"],
  },
  {
    id: 7,
    name: "Rosemary",
    slug: "rosemary",
    image: "https://placehold.co/400x400?text=Rosemary",
    description: "Stimulates memory, relieves pain, and boosts circulation.",
    scientificName: "Rosmarinus officinalis",
    commonUses: "Memory support, cooking, topical muscle rubs.",
    healingBenefits:
      "Anti-inflammatory, improves blood circulation, enhances concentration.",
    benefits:
      "Rosemary contains antioxidants and anti-inflammatory compounds that help boost the immune system and improve blood circulation.",
    culinary:
      "Used as a spice for meats, potatoes, and soups. Often infused in oils for marinades.",
    remedies:
      "Rosemary Hair Rinse: Boil fresh rosemary in water, cool, and use as a scalp rinse to stimulate growth.",
    productLinks: ["Rosemary Essential Oil"],
  },
  // Add more herbs with slugs
  {
    name: "Lavender",
    slug: "lavender",
    image: "https://placehold.co/800x400?text=Lavender",
    scientificName: "Lavandula angustifolia",
    commonUses: "Relaxation, sleep aid",
    healingBenefits: "Calming, anti-anxiety",
    benefits:
      "Lavender is known for its calming properties and is often used to reduce stress and anxiety.",
    culinary: "Used in teas, desserts, and as a flavoring in syrups.",
    remedies:
      "Lavender sachets for relaxation or lavender oil for aromatherapy.",
    productLinks: ["Lavender Essential Oil"],
  },
  {
    name: "Echinacea",
    slug: "echinacea",
    image: "https://placehold.co/800x400?text=Echinacea",
    scientificName: "Echinacea purpurea",
    commonUses: "Immune support, cold prevention",
    healingBenefits: "Boosts immune system, anti-inflammatory",
    benefits:
      "Echinacea is commonly used to prevent colds and flu by boosting the immune system.",
    culinary: "Can be made into teas or tinctures.",
    remedies: "Echinacea tea or tincture to help fight off colds.",
    productLinks: ["Echinacea Extract"],
  },
  // Add more herbs with slugs
];

export default herbs;
